import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const ExistingEstateDocuments = () => {
  const {
    register,
    watch
  } = useFormContext();
  const hasExistingWill = watch('existingDocuments.hasWill');
  const [primaryTrustees, setPrimaryTrustees] = useState([{
    id: 1
  }]);
  const [alternateTrustees, setAlternateTrustees] = useState([{
    id: 1
  }]);
  const addPrimaryTrustee = () => {
    const newId = primaryTrustees.length > 0 ? Math.max(...primaryTrustees.map(t => t.id)) + 1 : 1;
    setPrimaryTrustees([...primaryTrustees, {
      id: newId
    }]);
  };
  const removePrimaryTrustee = (id: number) => {
    setPrimaryTrustees(primaryTrustees.filter(t => t.id !== id));
  };
  const addAlternateTrustee = () => {
    const newId = alternateTrustees.length > 0 ? Math.max(...alternateTrustees.map(t => t.id)) + 1 : 1;
    setAlternateTrustees([...alternateTrustees, {
      id: newId
    }]);
  };
  const removeAlternateTrustee = (id: number) => {
    setAlternateTrustees(alternateTrustees.filter(t => t.id !== id));
  };
  return <div className="space-y-8" data-id="element-631" data-mp="14d9c20d7ck2x">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-632" data-mp="14a3myl4kpi77">
        <p className="text-slate-700" data-id="element-633" data-mp="zc233xzbpeuo">
          Please provide information about any existing estate planning
          documents you may have.
        </p>
      </div>

      {/* Existing Will */}
      <div className="space-y-4" data-id="element-634" data-mp="19baucj2t0fdc">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-635" data-mp="1n2y1jdyab8aw">
          Existing Will
        </h3>

        <div data-id="element-636" data-mp="1i3l6w7168wxr">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-637" data-mp="1i561txreehw5">
            Do you have an existing Will (including in other jurisdictions)?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-638" data-mp="1s2ar46gjith6">
            <label className="inline-flex items-center" data-id="element-639" data-mp="1s3vhrkzqhs9r">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('existingDocuments.hasWill')} data-id="element-640" data-mp="1z60hbj3myhpu" />
              <span className="ml-2" data-id="element-641" data-mp="292mzg04kuuo6">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-642" data-mp="2dun5mab8qjt7">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('existingDocuments.hasWill')} data-id="element-643" data-mp="2dvg7awvcej4h" />
              <span className="ml-2" data-id="element-644" data-mp="2mwo2h62kb3uc">No</span>
            </label>
          </div>

          {hasExistingWill === 'true' && <div className="mb-4" data-id="element-645" data-mp="2wtizfkj6sw6i">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-646" data-mp="2wshaqd990b6b">
                In which jurisdiction(s) do you have an existing Will?
              </label>
              <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Ontario, British Columbia, United States" {...register('existingDocuments.willJurisdictions')} data-id="element-647" data-mp="12ege7z16809e" />
            </div>}
        </div>
      </div>

      {/* Primary Estate Trustees */}
      <div className="space-y-4" data-id="element-648" data-mp="g846jwwipovy">
        <div className="flex justify-between items-center" data-id="element-649" data-mp="g4q3snjxzdnz">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-650" data-mp="1dt03ux063rcg">
            Primary Estate Trustee(s)
          </h3>
          <button type="button" onClick={addPrimaryTrustee} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-651" data-mp="13w582lva451v">
            <PlusIcon size={16} className="mr-1" data-id="element-652" data-mp="yz52ec2cd4ba" />
            Add Trustee
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-653" data-mp="3ok02dlomi0r0">
          <p className="text-sm text-blue-800" data-id="element-654" data-mp="3jlyjb0r761fj">
            You may name one or more Primary Estate Trustees (also called
            Executors). They will be responsible for administering your estate
            after your death.
          </p>
        </div>

        {primaryTrustees.map((trustee, index) => <div key={trustee.id} className="p-4 bg-slate-50 rounded-md" data-id="element-655" data-mp="12bsm8aqbe0gb" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-656" data-mp="17dhuxjq2e218">
              <h4 className="font-medium" data-id="element-657" data-mp="1v2axhz16z84t">Primary Trustee {index + 1}</h4>
              {primaryTrustees.length > 1 && <button type="button" onClick={() => removePrimaryTrustee(trustee.id)} className="text-red-500 hover:text-red-700" data-id="element-658" data-mp="200cb44fumf8w">
                  <TrashIcon size={16} data-id="element-659" data-mp="1q1wks3onba0g" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-660" data-mp="9nobhasvyx6r">
              <div data-id="element-661" data-mp="eokqokiou5rh">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-662" data-mp="ep3y37appbr9">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter trustee's name" {...register(`estateTrustees.primary.${index}.name`)} data-id="element-663" data-mp="2su8w5yfykczg" />
              </div>
              <div data-id="element-664" data-mp="2a52m0zt8ctp9">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-665" data-mp="2a6nemjvzi2kh">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register(`estateTrustees.primary.${index}.relationship`)} data-id="element-666" data-mp="258c3m5tydm0o" />
              </div>
              <div data-id="element-667" data-mp="1meyh8p4b2nwo">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-668" data-mp="1mfhzk6xvbeb8">
                  City
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter city" {...register(`estateTrustees.primary.${index}.city`)} data-id="element-669" data-mp="3lioveu93zea5" />
              </div>
            </div>
          </div>)}
      </div>

      {/* Alternate Estate Trustees */}
      <div className="space-y-4" data-id="element-670" data-mp="37kqfhkf539sj">
        <div className="flex justify-between items-center" data-id="element-671" data-mp="37lrsvvjmo8df">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-672" data-mp="3ckcsptuywq1c">
            Alternate Estate Trustee(s)
          </h3>
          <button type="button" onClick={addAlternateTrustee} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-673" data-mp="3hkr51o3lqm56">
            <PlusIcon size={16} className="mr-1" data-id="element-674" data-mp="wrw321dty8je" />
            Add Trustee
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-675" data-mp="2h9og85mv25zz">
          <p className="text-sm text-blue-800" data-id="element-676" data-mp="2cbmwdihm22ng">
            Alternate Trustees act if your Primary Trustee(s) are unable or
            unwilling to serve. You may name one or more alternates.
          </p>
        </div>

        {alternateTrustees.map((trustee, index) => <div key={trustee.id} className="p-4 bg-slate-50 rounded-md" data-id="element-677" data-mp="1xmqs7wiod9s4" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-678" data-mp="1xkw7ai7elho1">
              <h4 className="font-medium" data-id="element-679" data-mp="1tklvuq0udz1s">Alternate Trustee {index + 1}</h4>
              {alternateTrustees.length > 1 && <button type="button" onClick={() => removeAlternateTrustee(trustee.id)} className="text-red-500 hover:text-red-700" data-id="element-680" data-mp="1ooet163qt3o2">
                  <TrashIcon size={16} data-id="element-681" data-mp="3ixz6ewzjsjbc" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-682" data-mp="3dzfl8yss3bk1">
              <div data-id="element-683" data-mp="2mwekldodxj62">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-684" data-mp="2mxzd6xr52s1a">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate trustee's name" {...register(`estateTrustees.alternate.${index}.name`)} data-id="element-685" data-mp="2d6328m3yf7fn" />
              </div>
              <div data-id="element-686" data-mp="2962oz4sld2a6">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-687" data-mp="292exscamcrym">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register(`estateTrustees.alternate.${index}.relationship`)} data-id="element-688" data-mp="1z6261jymwo6i" />
              </div>
              <div data-id="element-689" data-mp="1cyet1dkw0wzu">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-690" data-mp="1cyy0g0cww2zm">
                  City
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter city" {...register(`estateTrustees.alternate.${index}.city`)} data-id="element-691" data-mp="1rodoh8l25ubm" />
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};
export default ExistingEstateDocuments;